// Layout.jsx
import { Outlet, useParams } from "react-router";
import { useEffect, useState } from "react";
import Header from "./Header";
import TablePromptPage from "../Pages/TablePromptPage";
import { useApp } from "../Context";
import { validateTable } from "../api/apis";

export default function Layout() {
  const { restaurant, orderId } = useParams();
  const { table: contextTable, setTable, setMenu } = useApp();
  const [loading, setLoading] = useState(true);
  const [closed, setClosed] = useState(false)
  const [validTable, setValidTable] = useState(true);
  const [localTable, setLocalTable] = useState(() => {
    const pathname = window.location.pathname;
    const rawHash = window.location.hash.replace("#", "").trim();
    const isRootPath = !pathname.includes("/order");
    return isRootPath && rawHash ? rawHash : contextTable || "";
  });

  useEffect(() => {
    const init = async () => {
      if (!localTable) {
        setValidTable(false);
        setLoading(false);
        return;
      }

      try {
        const { valid, menus, closed } = await validateTable(localTable);
        console.log(closed)
        if(closed){setClosed(true)}
        else{
          setClosed(false)
        }
        if (valid) {
          setTable(localTable);
          setMenu(menus);
        } else {
          setValidTable(false);
        }
      } catch (err) {
        console.error("Validation error:", err);
        setValidTable(false);
      } finally {
        setLoading(false);
      }
    };

    init();
  }, [restaurant]);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-warning pt-2" />
        <h3>Laddar...</h3>
      </div>
    );
  }

  if(closed)return <Closed/>

  if ((!contextTable || !validTable) && !orderId) {
    return <TablePromptPage />;
  }

  return (
    <div className="rounded min-vh-100 m-auto" style={{ maxWidth: '500px' }}>
      <Header />
      <Outlet />
    </div>
  );
}

function Closed() {
  return (
    <div className="min-vh-100 d-flex flex-column align-items-center justify-content-center px-3 m-auto" style={{ maxWidth: '500px' }}>
      <Header />
      <div className="text-center mb-5">
        <h3 className="mb-2">Restaurangen är stängd</h3>
        <h5 className="text-muted">Vänligen försök igen under öppettiderna</h5>
      </div>
    </div>
  );
}
